import { fetchFromApi } from '../../helpers/api';
import { buildDbTime } from './time-utils';

export const JobsActionTypes = {
  CLEAR_JOB: 'JOBS/CLEAR_JOB',

  GET_JOB_REQUEST: 'JOBS/GET_JOB_REQUEST',
  GET_JOB_SUCCESS: 'JOBS/GET_JOB_SUCCESS',
  GET_JOB_FAILURE: 'JOBS/GET_JOB_FAILURE',

  GET_JOBS_REQUEST: 'JOBS/GET_JOBS_REQUEST',
  GET_JOBS_SUCCESS: 'JOBS/GET_JOBS_SUCCESS',
  GET_JOBS_FAILURE: 'JOBS/GET_JOBS_FAILURE',

  CREATE_JOB_REQUEST: 'JOBS/CREATE_JOB_REQUEST',
  CREATE_JOB_SUCCESS: 'JOBS/CREATE_JOB_SUCCESS',
  CREATE_JOB_FAILURE: 'JOBS/CREATE_JOB_FAILURE',

  UPDATE_JOB_REQUEST: 'JOBS/UPDATE_JOB_REQUEST',
  UPDATE_JOB_SUCCESS: 'JOBS/UPDATE_JOB_SUCCESS',
  UPDATE_JOB_FAILURE: 'JOBS/UPDATE_JOB_FAILURE',

  DELETE_JOB_REQUEST: 'JOBS/DELETE_JOB_REQUEST',
  DELETE_JOB_SUCCESS: 'JOBS/DELETE_JOB_SUCCESS',
  DELETE_JOB_FAILURE: 'JOBS/DELETE_JOB_FAILURE'
};

export const clearJob = () => {
  return {
    type: JobsActionTypes.CLEAR_JOB
  };
};

export const getJob = id => {
  const headers = new Headers();

  const init = {
    method: 'GET',
    headers
  };

  return {
    types: [
      JobsActionTypes.GET_JOB_REQUEST,
      JobsActionTypes.GET_JOB_SUCCESS,
      JobsActionTypes.GET_JOB_FAILURE
    ],
    shouldCallApi: state => state.auth.get('isAuthenticated'),
    callApi: dispatch => fetchFromApi(`jobs/${id}/`, init, dispatch)
  };
};

export const getJobs = () => {
  const headers = new Headers();

  const init = {
    method: 'GET',
    headers
  };

  return {
    types: [
      JobsActionTypes.GET_JOBS_REQUEST,
      JobsActionTypes.GET_JOBS_SUCCESS,
      JobsActionTypes.GET_JOBS_FAILURE
    ],
    shouldCallApi: state => state.auth.get('isAuthenticated'),
    callApi: dispatch => fetchFromApi('jobs/', init, dispatch)
  };
};

export const updateJob = (formData, id) => {
  const { date, start_time, end_time, time_zone } = formData;
  const startDbTime = buildDbTime(date, start_time, time_zone);
  const endTime = buildDbTime(date, end_time, time_zone);
  const endDbTime = endTime === 'Invalid date' ? null : endTime;

  const payload = new FormData();
  payload.append('start_time', startDbTime);
  if (endDbTime) {
    payload.append('end_time', endDbTime);
  }

  Object.keys(formData).forEach(key => {
    if (key === 'translation_document') {
      if (formData[key]) {
        payload.append(key, formData[key][0]);
      }
    } else if (!key.includes('_time')) {
      payload.append(key, formData[key]);
    }
  });

  const init = {
    method: 'PUT',
    body: payload
  };

  return {
    types: [
      JobsActionTypes.UPDATE_JOB_REQUEST,
      JobsActionTypes.UPDATE_JOB_SUCCESS,
      JobsActionTypes.UPDATE_JOB_FAILURE
    ],
    shouldCallApi: state =>
      state.auth.get('isAuthenticated') && !state.jobs.get('isLoading'),
    callApi: dispatch => fetchFromApi(`jobs/${id}/`, init, dispatch)
  };
};

export const createJob = formData => {
  const { date, start_time, end_time, time_zone } = formData;
  const startDbTime = buildDbTime(date, start_time, time_zone);
  const endTime = buildDbTime(date, end_time, time_zone);
  const endDbTime = endTime === 'Invalid date' ? null : endTime;

  const payload = new FormData();
  payload.append('start_time', startDbTime);
  if (endDbTime) {
    payload.append('end_time', endDbTime);
  }

  Object.keys(formData).forEach(key => {
    if (key === 'translation_document') {
      if (formData[key]) {
        payload.append(key, formData[key][0]);
      }
    } else if (!key.includes('_time')) {
      payload.append(key, formData[key]);
    }
  });

  const init = {
    method: 'POST',
    body: payload
  };

  return {
    types: [
      JobsActionTypes.CREATE_JOB_REQUEST,
      JobsActionTypes.CREATE_JOB_SUCCESS,
      JobsActionTypes.CREATE_JOB_FAILURE
    ],
    shouldCallApi: state =>
      state.auth.get('isAuthenticated') && !state.jobs.get('isLoading'),
    callApi: dispatch => fetchFromApi('jobs/', init, dispatch)
  };
};

export const deleteJob = id => {
  const headers = new Headers();

  const init = {
    method: 'DELETE',
    headers
  };
  return {
    types: [
      JobsActionTypes.DELETE_JOB_REQUEST,
      JobsActionTypes.DELETE_JOB_SUCCESS,
      JobsActionTypes.DELETE_JOB_FAILURE
    ],
    payload: { id: id },
    shouldCallApi: state => state.auth.get('isAuthenticated'),
    callApi: dispatch => fetchFromApi(`jobs/${id}/`, init, dispatch)
  };
};



/** WEBPACK FOOTER **
 ** ./src/state/jobs/actions.js
 **/